<template>
    <div class="view pa24">
        <el-button type="primary" class="batchBtn"  @click="batchPrintAll()">批量打印</el-button>
        <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            @selection-change="handleSelectionChange"    
        >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="orderName" align="center" label="订单" />
            <el-table-column prop="model" align="center" label="型号" />
            <el-table-column prop="specName" align="center" label="规格">
            </el-table-column>
            <el-table-column prop="gyNo" align="center" label="工艺号">
            </el-table-column>
            <el-table-column prop="num" align="center" label="数量">
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="创建时间" />
            <el-table-column align="center" width="200" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="printBtn(scope.row)">打印</el-button>
                    <!-- 删除 -->
                    <el-button type="text" @click="deleteAll(scope.row)" style="color: red;">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper"
                class="" :total="total" :pager-count="5" />
        </div>
        <code-print ref="codePrint"></code-print>
    </div>
</template>
<script>
    import { selectCodePrintList, addCodePrint, delCodePrint,del } from '@/api/storePrint.js'
    import CodePrint from "./component/codePrint.vue";
    export default {
        components: {
            CodePrint
        },
        props: {
        },
        data() {
            return {
                name: null,
                tableData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                form: {
                },
                rules: {
                },
                multipleSelection: []
            };
        },
        created() {
            this.getList()
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            batchPrintAll() {
                if (this.multipleSelection.length > 0) {
                    this.$refs.codePrint.visiblePrint = true
                    this.$refs.codePrint.init(this.multipleSelection, 'all')
                } else {
                    this.$message.warning('请选择要打印的数据');
                }
            },
            getCustomer() {
                this.getList()
            },
            handleSizeChange(num) {
                this.pageSize = num;
                this.pageNum = 1;
                this.getList();
            },
            handleCurrentChange(num) {
                this.pageNum = num;
                this.getList();
            },
            getList() {
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }
                selectCodePrintList(params).then(res => {
                    this.tableData = res.data.list
                    this.total = res.data.total
                })
            },
            toForm(type, data) {
                if ('add' == type) {
                    this.dialogFormVisible = true
                } else if ('edit' == type) {
                    this.form = data
                    this.dialogFormVisible = true
                }
            },
            submitForm() {
                addCodePrint(this.form).then(res => {
                    this.$nextTick(() => {
                        this.$refs.form.resetFields()
                    })
                    this.$message.success("操作成功")
                    this.getList()
                    this.dialogFormVisible = false
                })
            },
            del(data) {
                this.$confirm('此操作将永久删除该规格, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delCodePrint({ id: data.id }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getList()
                    })
                }).catch(() => {

                });
            },
            printBtn(data) {
                this.$refs.codePrint.visiblePrint = true
                console.log(data);
                this.$refs.codePrint.init(data, 'one')
            },
                      deleteAll(row) {
                // 弹出确认对话框，提示用户是否继续删除操作
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        // 修正参数错误，正确传递 id
                        id: row.id
                    }
                    // 调用删除接口
                    del(params).then(res => {
                        // 删除成功提示
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        // 重新获取列表数据
                        this.getList()
                    }).catch(() => {
                        // 删除失败提示
                        this.$message({
                            type: 'error',
                            message: '删除失败，请重试!'
                        });
                    });
                }).catch(() => {
                    // 用户取消操作提示
                    this.$message({
                        type: 'info',
                        message: '已取消删除操作'
                    });
                });
            }

        },
    }
</script>
<style scoped>
    .pageBox {
        display: flex;
        justify-content: flex-end;
    }
    .batchBtn {
        margin-bottom: 20px;
    }
</style>